/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const Stairs = (props) => (
  <SvgIcon {...props} viewBox="-35 -35 100 125">
    <polygon
      points="27.9,2.1 19.3,2.1 10.7,2.1 10.7,10.7 10.7,19.3 2.1,19.3 -6.5,19.3 -6.5,27.9 -6.5,36.5 -28,36.5 -28,45.1 2.1,45.1 2.1,27.9 19.3,27.9 19.3,10.7 36.5,10.7 36.5,-6.5 58,-6.5 58,-15.1 36.5,-15.1 27.9,-15.1 27.9,-6.5 "
      id="polygon4"
      transform="matrix(1.080065,0,0,1.4399178,0.12317705,6.6427586)"
    />
  </SvgIcon>
);

export default Stairs;
